import {
  Button,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeaderWithIllustration,
} from '@dev-spendesk/grapes';
import React, { useId } from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import CaroleCooper from 'modules/StrongCustomerAuthentication/images/carole-cooper.svg';
import QrCode from 'modules/StrongCustomerAuthentication/images/qr-code.svg';
import ScanToDownload from 'modules/StrongCustomerAuthentication/images/scan-to-download.svg';

interface CreateMobileFactorProps {
  handleClose: () => void;
  handleBack: () => void;
}

export const CreateMobileFactor = ({
  handleClose,
  handleBack,
}: CreateMobileFactorProps) => {
  const { t } = useTranslation('global');
  const id = useId();

  return (
    <ModalContent aria-labelledby={id} onClose={handleClose}>
      <ModalHeaderWithIllustration
        illustration={
          <div className="bg-background-secondary-brand-default rounded-t-12 flex w-full flex-row items-center justify-center gap-16 pt-[72px]">
            <img src={ScanToDownload} alt="Scan to download" />
            <img
              className="bg-background-primary-default rounded-12 h-auto w-[180px] p-16"
              src={QrCode}
              alt="QR code"
            />
            <img src={CaroleCooper} alt="" />
          </div>
        }
        illustrationHeight="320px"
        title={t('profile.authenticationFactors.create.mobile.title')}
      />
      <ModalBody>
        <p className="body-m text-content-secondary-bg-primary">
          {t('profile.authenticationFactors.create.mobile.description')}
        </p>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="secondaryNeutral"
          text={t('profile.authenticationFactors.create.chooseOtherMethod')}
          iconName="arrow-left"
          iconPosition="left"
          onClick={handleBack}
        />
        <Button
          variant="primaryBrand"
          text={t('misc.done')}
          onClick={handleClose}
        />
      </ModalFooter>
    </ModalContent>
  );
};
